import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../Utils/fileUtils";
import TextInput from "../Common/FormElements/TextInput/TextInput";
import CalendarInput from "../Common/FormElements/CalendarInput/CalendarInput";
import moment from "moment";
import Button from "../Common/FormElements/Button/Button";
import { toast } from "react-toastify";
import API from "../../Api/Api";

const AvoirDetails = ({ data }) => {
  const { t } = useTranslation("common");
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  const commande = data?.attributes?.commande?.data?.attributes;
  const reseller = data?.attributes?.reseller?.data?.attributes;

  const clientDetails = [
    { label: t("Store"), value: reseller?.name },
    { label: t("Order No."), value: commande?.number },
    {
      label: t("Order date"),
      value: commande?.date ? formatDate(commande?.date, "DD/MM/YYYY") : null,
    },
  ];
  const avoirDetails = [
    { label: t("Credit No."), value: data?.attributes?.number, name: "number" },
    {
      name: "date",
      label: t("Credit Date"),
      value: data?.attributes?.date
        ? formatDate(data?.attributes?.createdAt, "DD/MM/YYYY")
        : null,
    },
  ];

  const updateAvoir = async () => {
    setLoading(true);
    try {
      await API.put(`/api/avoirs/${data?.id}`, {
        data: {
          number: formData?.number,
          date: moment(formData?.date).utc(true).toDate(),
        },
      });

      toast.success(t("Credit has been updated"));
    } catch (error) {
      toast.error(t("An error occurred while updating the credit"));
    } finally {
      setLoading(false);
    }
  };

  const isUpdated =
    +formData?.number !== +data?.attributes?.number ||
    moment(formData?.date).format("DD/MM/YYYY") !==
      moment(data?.attributes?.date).format("DD/MM/YYYY");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    setFormData({
      number: data?.attributes?.number,
      date: data?.attributes?.date,
    });
  }, [data]);

  return (
    <div>
      <h1 className="quickSand f30 bold text-blue mb-3">
        {data?.attributes?.state === "draft"
          ? t("Credit Creation")
          : t("Credit Modification")}
      </h1>
      <div className="d-flex flex-column gap-3">
        <div className="d-flex flex-column p-2 border-1 border-gray-500 bold">
          <div className="d-flex gap-1">
            <span>1- {t("Client details")}</span>
          </div>
          {clientDetails.map(
            ({ label, value }, index) =>
              value && (
                <div className="d-flex gap-1" key={index}>
                  <span>{label} :</span>
                  <span>{value ?? ""}</span>
                </div>
              )
          )}
        </div>
        <div className="d-flex flex-column p-2 border-1 border-gray-500 bold">
          <div className="d-flex gap-1">
            <span>2- {t("Credit details")}</span>
          </div>
          <div className="max-w-350px">
            {avoirDetails.map(
              ({ label, value, name }, index) =>
                value && (
                  <div className="gap-1 alignH mt-2" key={index}>
                    <span className="me-auto">{label} :</span>
                    <div className="max-w-200px">
                      {name === "number" && (
                        <TextInput
                          name={name}
                          value={formData[name]}
                          callback={handleChange}
                        />
                      )}
                      {name === "date" && (
                        <CalendarInput
                          name={name}
                          value={
                            moment(formData?.date).utc(true).toDate() || null
                          }
                          callback={(e) => handleChange(e)}
                        />
                      )}
                    </div>
                  </div>
                )
            )}
          </div>
          {isUpdated && (
            <div className="mt-2 max-w-350px">
              <Button
                className="ms-auto max-w-200px w-100"
                loading={loading}
                onClick={updateAvoir}
              >
                {t("Save")}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AvoirDetails;
